module.exports = __webpack_public_path__ + "img/IMG_9704.e7464def.jpeg";